import React from 'react';
import { ChangePassword } from './ChangePassword';
import { PageHeader } from '../../../shared/components';
import { PageLayout } from '../../../shared/layout/page/PageLayout';
import { IEnrichedPageEntry } from '../../../app/pages/domain/models/IEnrichedPageEntry';

interface IChangePasswordPageProps {
	page: IEnrichedPageEntry;
}

export const ChangePasswordPage = ({ page }: IChangePasswordPageProps) => (
	<PageLayout hideFooterOnMobile>
		<PageHeader page={page} />
		<ChangePassword />
	</PageLayout>
);
